import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineDownload } from 'react-icons/hi';
import { HiOutlinePhone } from "react-icons/hi";
import { HiOutlineNewspaper } from "react-icons/hi";
import { HiOutlinePencil } from "react-icons/hi";
import { HiOutlineInformationCircle } from "react-icons/hi";
import { HiOutlineBriefcase } from "react-icons/hi";
import { IoMenu } from "react-icons/io5";
import { IoLanguage } from 'react-icons/io5';

function Navbar() {
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showLangs, setShowLangs] = useState(false);
    const handleShowMenu = () => {
        setShowLangs(false);
        setIsMenuOpen(!isMenuOpen)
    };
    const handleShowOpts = () => {
        setShowLangs(!showLangs);
        setIsMenuOpen(false)
    };
    const handleChangeLng = (lng) => {
        i18n.changeLanguage(lng);
        setShowLangs(!showLangs);
    }
    return (
        <nav className="unselectable">
            <div className=" h-16 my-8 mx-8">
                <div className="flex justify-between my-auto">
                    <div className='hidden lg:flex '>

                    </div>
                    <div className="hidden lg:flex m-auto justify-between
                    align-middle items-center space-x-10 mx-2">
                        {/* <NavItem href="#" label={t('blog')} icon={<HiOutlineNewspaper size={25} />} /> */}
                        <NavItem href="#about-section" label={t('about')} icon={<HiOutlineInformationCircle size={25} />} />
                        {/* <NavItem href="#experience-section" label={t('experience')} icon={<HiOutlineBriefcase size={25} />} /> */}
                        <NavItem href="#contact-section" label={t('contact')} icon={<HiOutlinePhone size={25} />} />
                        <NavItem href="https://sinaranaei.ir/SinaRanaei.pdf" label={t('resume')} icon={<HiOutlineDownload size={25} />} />
                    </div>

                    <div onClick={() => handleShowMenu()} className="lg:hidden flex items-center btn
                    drop-shadow-glowWhite text-white hover:text-[#66B933]
                    text-2xl cursor-pointer border-2 py-2 px-2
                    border-[#FFFFFF] hover:border-[#66B933] rounded-xl mx-2">
                        <button >
                            <IoMenu size={25} className='drop-shadow-glowWhite' />
                        </button>
                    </div>

                    <div onClick={() => handleShowOpts()} className="flex items-center btn
                    drop-shadow-glowWhite text-white hover:text-[#66B933]
                    text-2xl cursor-pointer border-2 py-2 px-2
                    border-[#FFFFFF] hover:border-[#66B933] rounded-xl mx-2">
                        <button >
                            <IoLanguage size={25} className='drop-shadow-glowWhite' />
                        </button>
                    </div>
                </div>



            </div>
            {showLangs && (
                <div className=" flex justify-center flex-col space-y-4 my-4 mx-8  ">
                    <div
                        onClick={() => handleChangeLng('en')}
                    >
                        <NavItem href="#" label={'English'} />

                    </div>
                    <div
                        onClick={() => handleChangeLng('fa')}
                    >
                        <NavItem href="#" label={'فارسی'} />

                    </div>
                    {/* <div
                        onClick={() => handleChangeLng('sorani')}
                    >
                        <NavItem href="#" label={'سۆرانی'} />

                    </div>
                    <div
                        onClick={() => handleChangeLng('kurmanci')}
                    >
                        <NavItem href="#" label={'Kurmanci'} />
                    </div> */}
                </div>
            )}
            {isMenuOpen && (
                <div className="lg:hidden flex justify-center flex-col space-y-4 my-4 mx-8">
                    {/* <button onClick={() => handleShowMenu()}>
                        <NavItem href="#" label={t('blog')} icon={<HiOutlineNewspaper size={25} />}/>
                    </button> */}
                    <button onClick={() => handleShowMenu(!isMenuOpen)}>
                        <NavItem href="#about-section" label={t('about')} icon={<HiOutlineInformationCircle size={25} />}/>
                    </button>
                    {/* <button onClick={() => handleShowMenu(!isMenuOpen)}> 
                        <NavItem href="#experience-section" label={t('experience')} icon={<HiOutlineBriefcase size={25} />}/>
                    </button> */}
                    <button  onClick={() => handleShowMenu(!isMenuOpen)}>
                        <NavItem href="#contact-section" label={t('contact')} icon={<HiOutlinePhone size={25} />}/>
                    </button>
                    <button>
                        <NavItem href="#" label={t('resume')} icon={<HiOutlineDownload size={25} />} />
                    </button>
                </div>
            )}
        </nav>
    );
}

function NavItem({ href, label, icon }) {
    return (
        <a href={href} className=" drop-shadow-glowWhite text-white text-center hover:text-[#66B933] rounded-sm
         text-2xl font-extralight"
        >
            <div className="justify-center btn cursor-pointer border-2 py-2 px-4 border-[#FFFFFF] hover:border-[#66B933] rounded-xl flex items-center space-x-2">
                {icon && <div>{icon}</div>}
                <p>{label}</p>
            </div>
        </a>
    );
}

export default Navbar;
